import { createReducer } from '@reduxjs/toolkit'

import { addTicket, receivedReservation, receivedSummary, removeTicket } from '../../actions/actions'
import { addTicketToBooking, mapReservationResponseToBooking, removeTicketFromBooking } from './bookingHelpers'

const initialState = {
  totalMoney: 0,
  totalPoints: 0,
  services: []
}

const booking = createReducer(initialState, {
  [receivedSummary]: (state, { payload }) => {
    state.totalMoney = payload.price
  },
  [receivedReservation]: (state, { payload: reservationResponse }) =>
    mapReservationResponseToBooking(reservationResponse),
  [addTicket]: (state, { payload: ticket }) => {
    addTicketToBooking(state, ticket)
  },
  [removeTicket]: (state, { payload: ticket }) => {
    removeTicketFromBooking(state, ticket)
  }
})

export default booking
